import React from 'react';
import PropTypes from 'prop-types';

// Cross-calculator navigation links component
const SMSFRelatedCalculators = ({ currentCalculator, onNavigate, smsfState }) => {
    // Define relationships between calculators
    const relatedCalculators = {
        'division293': [
            { id: 'carry_forward', reason: 'Use carry-forward to reduce Division 293 tax', icon: '📅' },
            { id: 'pension_optimizer', reason: 'Transition to pension for 0% tax', icon: '💰' }
        ],
        'carry_forward': [
            { id: 'division293', reason: 'Check if high contributions trigger Division 293', icon: '💵' },
            { id: 'work_test', reason: 'Verify work test compliance for ages 67-74', icon: '⏱️' }
        ],
        'lrba': [
            { id: 'limits_monitor', reason: 'Monitor LVR and borrowing capacity', icon: '📊' },
            { id: 'cashflow', reason: 'Model loan repayments and cash flow', icon: '💹' }
        ],
        'pension_optimizer': [
            { id: 'tax_harvesting', reason: 'Optimize tax on pension assets', icon: '📉' },
            { id: 'succession', reason: 'Plan reversionary pensions', icon: '👨‍👩‍👧‍👦' }
        ],
        'co_contribution': [
            { id: 'bring_forward', reason: 'Maximize non-concessional with bring-forward', icon: '🔄' },
            { id: 'spouse_split', reason: 'Optimize family contributions', icon: '💑' }
        ],
        'downsizer': [
            { id: 'pension_optimizer', reason: 'Convert to pension for tax-free income', icon: '💰' },
            { id: 'estate', reason: 'Plan estate with larger balance', icon: '📜' }
        ],
        'limits_monitor': [
            { id: 'lrba', reason: 'Calculate optimal LRBA structure', icon: '🏛️' },
            { id: 'related_party', reason: 'Track related party transactions', icon: '👥' }
        ],
        'collectibles': [
            { id: 'limits_monitor', reason: 'Ensure collectibles within limits', icon: '📊' },
            { id: 'valuation', reason: 'Get collectibles valued', icon: '🏠' }
        ],
        'comparison': [
            { id: 'wizard', reason: 'Complete setup if switching to SMSF', icon: '🧙‍♂️' },
            { id: 'dashboard', reason: 'View your SMSF overview', icon: '📊' }
        ],
        'dashboard': [
            { id: 'carry_forward', reason: 'Maximize contribution caps', icon: '📅' },
            { id: 'compliance', reason: 'Review compliance status', icon: '✅' },
            { id: 'reports', reason: 'Generate reports', icon: '📄' }
        ]
    };

    const related = relatedCalculators[currentCalculator] || [];

    if (related.length === 0) return null;

    return (
        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-lg shadow-sm border-l-4 border-blue-500">
            <h4 className="font-semibold text-blue-900 mb-3">🔗 Related Calculators</h4>
            <div className="space-y-2">
                {related.map(calc => (
                    <button
                        key={calc.id}
                        onClick={() => onNavigate(calc.id)}
                        className="w-full flex items-start p-3 bg-white rounded-lg hover:shadow-md transition border border-blue-200 hover:border-blue-400 text-left"
                    >
                        <span className="text-2xl mr-3">{calc.icon}</span>
                        <div className="flex-1">
                            <div className="font-medium text-blue-900 mb-1">
                                {getTabLabel(calc.id)}
                            </div>
                            <div className="text-sm text-blue-700">
                                {calc.reason}
                            </div>
                        </div>
                        <span className="text-blue-600 ml-2">→</span>
                    </button>
                ))}
            </div>
        </div>
    );
};

// Helper to get tab label
const getTabLabel = (tabId) => {
    const labels = {
        'carry_forward': 'Carry-Forward Calculator',
        'division293': 'Division 293 Tax',
        'pension_optimizer': 'Pension Optimizer',
        'work_test': 'Work Test Tool',
        'lrba': 'LRBA Calculator',
        'limits_monitor': 'Investment Limits Monitor',
        'cashflow': 'Cash Flow Modeling',
        'tax_harvesting': 'Tax Loss Harvesting',
        'succession': 'Succession Planning',
        'co_contribution': 'Gov Co-Contribution',
        'bring_forward': 'Bring-Forward Rule',
        'spouse_split': 'Spouse Splitting',
        'estate': 'Estate Planning',
        'related_party': 'Related Party Monitor',
        'valuation': 'Asset Valuation',
        'collectibles': 'Collectibles Manager',
        'wizard': 'Setup Wizard',
        'dashboard': 'Dashboard',
        'compliance': 'Compliance',
        'reports': 'Reporting Center'
    };
    return labels[tabId] || tabId;
};

SMSFRelatedCalculators.propTypes = {
    currentCalculator: PropTypes.string.isRequired,
    onNavigate: PropTypes.func.isRequired,
    smsfState: PropTypes.object
};

export default SMSFRelatedCalculators;

